import * as React from 'react';
import { Element } from 'react-scroll/modules';
import V4Result from './v4Result';
import V4Check from './v4Check';
import V4Notice from './v4Notice';
import TestGuideHeader from '../testGuideHeader';
import { Module } from '@domain/constant/acca/test/result/moduleType';
import classNames from 'classnames/bind';
import styles from './v4Guide.module.scss';

const cx = classNames.bind(styles);

const V4Guide = () => {
  return (
    <Element name={Module.VIDEO} className={cx('testGuideWrap')}>
      <TestGuideHeader moduleType={Module.VIDEO} />

      <div className={cx('contentWrap')}>
        <div className={cx('contentBox')}>
          {/* [D] 영상 종합 분석 결과 영역 */}
          <V4Result />
        </div>

        <div className={cx('contentBox')}>
          {/* [D] 내 영상 확인하기 영역 */}
          <V4Check />

          {/* [D] 도움말 영역 */}
          <V4Notice />
        </div>
      </div>
    </Element>
  );
};

export default V4Guide;
